module.exports = __webpack_public_path__ + "img/ambientacion1-zoom.f869278c.jpg";